import api from "./api";
import { gvmBouncerPath, gvmPath } from "./apiPaths";

export type AccountTypeOption = {
  label: string;
  value: string;
};

type AccountTypesResponse = {
  account_types?: AccountTypeOption[];
};

const ENDPOINT_NAME = "/account-types";

export type AccountTypesAuthMode = "vendor" | "bouncer";

export async function fetchAccountTypes(
  opts: { auth?: AccountTypesAuthMode } = {},
): Promise<AccountTypeOption[]> {
  const auth = opts.auth ?? "vendor";
  const url =
    auth === "vendor" ? gvmPath(ENDPOINT_NAME) : gvmBouncerPath(ENDPOINT_NAME);
  const config = auth === "vendor" ? { useVendorToken: true } : {};
  const res = (await api.get(
    url,
    config,
  )) as AccountTypesResponse | null;
  return res?.account_types ?? [];
}
